/* eslint-disable */
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect, useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import { DataGrid } from '@mui/x-data-grid';
import HighlightOffRoundedIcon from '@mui/material/Icon';

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

// Data
import authorsTableData from "layouts/all-tasks-view/data/authorsTableData";
import tasksViewTableData from "layouts/all-tasks-view/data/tasksViewTableData";
import tasksViewDataGrid from "layouts/all-tasks-view/data/tasksViewDataGrid";
import { toast } from "react-toastify";
import { AllInbox, CallMadeRounded, CallReceivedRounded, Diversity2Rounded } from "@mui/icons-material";
import { AppBar, Box, Icon, Tab, Tabs } from "@mui/material";

function Tables() {
  const [tasksType, setTasksType] = useState(() => {
    const data = localStorage.getItem("tasksType");
    return data !== null ? data : "tasks-asigned-to-me";
  });
  const [tasksData, setTasksData] = useState([]);
  const [tasksDataSorted, setTasksDataSorted] = useState([]);
  const [tabValue, setTabValue] = useState(() => {
    return localStorage.getItem("tasksStatusType") !== null ? parseInt(localStorage.getItem("tasksStatusType")) : 0;
  });
  const [updateTasksData, setUpdateTasksData] = useState(0);
  // const { columns: pColumns, rows: pRows } = tasksViewTableData(tasksData, setUpdateTasksData);
  // const reversedRows = [...pRows].reverse();
  const { columns: pDataGridColumns, rows: pDataGridRows } = tasksViewDataGrid(tasksDataSorted, setUpdateTasksData);
  const [isAdmin, setIsAdmin] = useState(true);

  // Menu
  const handleSetTabValue = (event, newValue) => {
    setTabValue(newValue);
    localStorage.setItem("tasksStatusType", newValue);
  }

  useEffect(()=>{
    // console.log("actual tabValue is: ");
    // console.log(tabValue);
    if(tabValue === 3){
      setTasksDataSorted(tasksData.filter(task => task.status === "zamknięte"));
    } 
    if(tabValue === 2){
      setTasksDataSorted(tasksData.filter(task => task.status === "anulowane"));
    } 
    if (tabValue === 1){
      setTasksDataSorted(tasksData.filter(task => (task.status !== "zamknięte" && task.status !== "anulowane")));
    }
    if (tabValue === 0){
      setTasksDataSorted(tasksData);
    }    
  }, [tabValue, tasksData]);

  // useEffect(()=>{
  //   console.log("tasksDataSorted now is: ");
  //   console.log(tasksDataSorted);
  // }, [tasksDataSorted]);

  const handleChangeTasksType = (event) => {
    setTasksType(event.target.value);
    localStorage.setItem("tasksType", event.target.value);
  };

  useEffect(() => {
    console.log(tasksType);
    console.log("updateTasksData is: "+updateTasksData);
    if(tasksType === "all-tasks"){
      getAllTasksShort();
    } else if(tasksType === "tasks-asigned-to-me"){
      getAllTasksShortToWorkerMe();
    } else if(tasksType === "tasks-created-by-me"){
      getAllTasksShortCreatedByMe();
    } else if(tasksType === "tasks-asigned-to-my-department"){
      getAllTasksShortToMyDepartment();
    } else if(tasksType === "tasks-attached-to-me"){
      getAllTasksShortAttachedToMe();
    }
  }, [tasksType, updateTasksData]);

  useEffect(() => {
    console.log("Ładowanie tasksData niżej");
    console.log(tasksData);
  }, [tasksData]);

  useEffect(() => {
    getUserID();
  }, []);

  const getAllTasksShort = async () => {
    try {
      const response = await fetch("https://devcolibri.pl/helpdesk-example/php/api/common-api.php/getAllTasksShort");
      const data = await response.json();
      setTasksData(data);
    } catch (error) {
      console.error("Błąd podczas pobierania danych z serwera AllTasksShort List:", error);
      toast.error(`Błąd podczas pobierania danych z serwera AllTasksShort List. ${error}`);
      setTasksData([]);
    }
  };

  const getAllTasksShortToWorkerMe = async () => {
    try {
      const response = await fetch("https://devcolibri.pl/helpdesk-example/php/api/common-api.php/getAllTasksShortToWorkerMe");
      const data = await response.json();
      setTasksData(data);
    } catch (error) {
      console.error("Błąd podczas pobierania danych z serwera AllTasksShortToWorkerMe List:", error);
      toast.error(`Błąd podczas pobierania danych z serwera AllTasksShortToWorkerMe List. ${error}`);
      setTasksData([]);
    }
  };

  const getAllTasksShortCreatedByMe = async () => {
    try {
      const response = await fetch("https://devcolibri.pl/helpdesk-example/php/api/common-api.php/getAllTasksShortCreatedByMe");
      const data = await response.json();
      setTasksData(data);
    } catch (error) {
      console.error("Błąd podczas pobierania danych z serwera AllTasksShortCreatedByMe List:", error);
      toast.error(`Błąd podczas pobierania danych z serwera AllTasksShortCreatedByMe List. ${error}`);
      setTasksData([]);
    }
  };

  const getAllTasksShortToMyDepartment = async () => {
    try {
      const response = await fetch("https://devcolibri.pl/helpdesk-example/php/api/common-api.php/getAllTasksShortToMyDepartment");
      const data = await response.json();
      setTasksData(data);
    } catch (error) {
      console.error("Błąd podczas pobierania danych z serwera AllTasksShortToMyDepartment List:", error);
      toast.error(`Błąd podczas pobierania danych z serwera AllTasksShortToMyDepartment List. ${error}`);
      setTasksData([]);
    }
  };

  const getAllTasksShortAttachedToMe = async () => {
    try {
      const response = await fetch("https://devcolibri.pl/helpdesk-example/php/api/common-api.php/getAllTasksShortAttachedToMe");
      const data = await response.json();
      setTasksData(data);
    } catch (error) {
      console.error("Błąd podczas pobierania danych z serwera getAllTasksShortAttachedToMe List:", error);
      toast.error(`Błąd podczas pobierania danych z serwera getAllTasksShortAttachedToMe List. ${error}`);
      setTasksData([]);
    }
  };

  const getUserID = async () => {
    try {
      const response = await fetch("https://devcolibri.pl/helpdesk-example/php/api/common-api.php/getUserID");
      const data = await response.json();
      data.status !== "fakeUser" && setIsAdmin(data.is_admin);
    } catch (error) {
      console.error("Błąd podczas pobierania danych z serwera AccountID: ", error);
      toast.error("Błąd podczas pobierania danych z serwera AccountID", error);
    }
  };

  const handlePageChange = (newPage) => {
    // setCurrentPage(newPage);
    sessionStorage.setItem("currentPage", newPage);
    console.log("currentPage is "+newPage);
  };

  const handlePageSizeChange = (newPageSize) => {
    // setPageSize(newPageSize);
    sessionStorage.setItem('pageSize', newPageSize);
    console.log("pageSize is "+newPageSize);
  };



  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              {/* <MDBox mx={2} mt={-3} py={3} px={2} variant="gradient" bgColor="info" borderRadius="lg" coloredShadow="info">
                <MDTypography variant="h6" color="white">
                  Zadania
                </MDTypography>
              </MDBox> */}
              <MDBox mx={2} mt={0} py={3} px={2}>
                <FormControl fullWidth sx={{ width: 1/2 }}>
                  <InputLabel id="tasks-type">Rodzaj zadania</InputLabel>
                  <Select
                    labelId="tasks-type"
                    id="tasks-type-select"
                    variant="standard"
                    value={tasksType}
                    label="Priorytet"
                    onChange={handleChangeTasksType}
                  >
                    {
                      isAdmin && <MenuItem value="all-tasks"><AllInbox fontSize="medium"/>Wszystkie zadania</MenuItem>
                    }
                    <MenuItem value="tasks-asigned-to-me"><CallReceivedRounded fontSize="medium"/>Zadania dla mnie</MenuItem>
                    <MenuItem value="tasks-asigned-to-my-department"><Diversity2Rounded fontSize="medium"/>Zadania dla mojego działu</MenuItem>
                    <MenuItem value="tasks-attached-to-me"><Diversity2Rounded fontSize="medium"/>Zadania połączone ze mną</MenuItem>
                    <MenuItem value="tasks-created-by-me"><CallMadeRounded fontSize="medium"/>Utworzone przeze mnie</MenuItem>
                  </Select>
                </FormControl>
                <Box mt={3}>
                  <AppBar position="static">
                    <Tabs orientation="horizontal" value={tabValue} onChange={handleSetTabValue}>
                      <Tab
                        label="Wszystkie"
                        icon={
                          <Icon fontSize="small" sx={{ mt: -0.25 }}>
                            apps
                          </Icon>
                        }
                      />
                      <Tab
                        label="Aktywne"
                        icon={
                          <Icon fontSize="small" sx={{ mt: -0.25 }}>
                            open_in_browser
                          </Icon>
                        }
                      />
                      <Tab
                        label="Anulowane"
                        icon={
                          <Icon fontSize="small" sx={{ mt: -0.25 }}>
                            block
                          </Icon>
                        }
                      />
                      <Tab
                        label="Zamknięte"
                        icon={
                          <Icon fontSize="small" sx={{ mt: -0.25 }}>
                            close
                          </Icon>
                        }
                      />
                    </Tabs>
                  </AppBar>
                </Box>
              </MDBox>
              
              {/* <MDBox pt={0}>
                <DataTable table={{ columns: pColumns, rows: reversedRows }} isSorted={false} entriesPerPage={false} showTotalEntries={true} />
              </MDBox> */}
              <MDBox pt={0}>
                <DataGrid columns={pDataGridColumns} rows={pDataGridRows.reverse()} 
                  // checkboxSelection
                  // disableClickEventBubbling={true}
                  // cellSelection={false}
                  rowSelection={false}
                  columnHeaderHeight={40}
                  initialState={{
                    pagination: { 
                      paginationModel: { 
                        pageSize: sessionStorage.getItem("pageSize") ? parseInt(sessionStorage.getItem("pageSize")) : 10,
                        page: sessionStorage.getItem("currentPage") ? parseInt(sessionStorage.getItem("currentPage")) : 0
                      } 
                    },
                  }}
                  pageSizeOptions={[5, 10, 25, 100]} 
                  onPageChange={(params) => handlePageChange(params.page)}
                  onPageSizeChange={(params) => handlePageSizeChange(params.pageSize)}

                  onPaginationModelChange={(params) => {
                    handlePageChange(params.page);
                    handlePageSizeChange(params.pageSize);
                  }}
                  
                  />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Tables;
